import React, { HTMLAttributes, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import Tabs from '@common/components/Tabs';
import { getRoute } from '@common/constants/CampusRoutes';

import { StyledGradeBookBasicHeader } from './styled';

interface PropsType extends HTMLAttributes<HTMLDivElement> {
	children: ReactNode;
}

function GradeBookBasicHeader({ children, ...props }: PropsType) {
	const { t } = useTranslation();
	return (
		<StyledGradeBookBasicHeader {...props}>
			<Tabs
				tabsWrapperStyles={{ padding: '0 16px' }}
				isRoute
				tabs={[
					{
						label: t('tabs.gradebook'),
						value: getRoute(['GRADEBOOK']),
					},
					{
						label: t('tabs.gradeBreakdown'),
						value: getRoute(['GRADEBOOK', 'MONTH']),
					},
				]}
			/>
			{children}
		</StyledGradeBookBasicHeader>
	);
}

export default GradeBookBasicHeader;
